module.exports = __webpack_public_path__ + "static/media/bannerImage.4588e580.jpg";